import React from 'react'

function AdminWorker() {
  return (
    <div>
    <div className="container" style={{backgroundColor:"#eef3f7"}}>
   <h1>Admin Worker</h1>

    </div>
      
    </div>
  )
}

export default AdminWorker
